import React from "react";
import { ShareableOrg } from "../../../services/orgSharing";
import LeaveOrgConfirm from "./LeaveOrgConfirm";
import UnshareOrgConfirm from "./UnshareOrgConfirm";
import { shareStatusOf } from "./useOrgSharing";

// F-492 (UAT, URS_6.8) — the confirmation behind the X on an organization row.
//
// ⭐ An ACCEPTED row asks the existing Leave question (`LeaveOrgConfirm` / `leaveOrgMessage`) —
// the X now LEAVES, so it says so, with the leave flow's own wording. It used to open a separate
// "Revoke Access" popup that ran the share-scoped DELETE, a second exit that did not agree with
// the first. A PENDING row keeps the "Cancel request?" copy: withdrawing a request is not leaving.
type Props = {
  org: ShareableOrg | null;
  /** "Parent · Location" (or the org's own name). */
  displayName: string;
  busy?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
};

const OrgRemoveConfirm: React.FC<Props> = ({ org, displayName, busy, onConfirm, onCancel }) =>
  org && shareStatusOf(org) === "pending" ? (
    <UnshareOrgConfirm
      org={org}
      displayName={displayName}
      onConfirm={async () => {
        await onConfirm();
      }}
      onCancel={onCancel}
    />
  ) : (
    <LeaveOrgConfirm
      orgLabel={org ? displayName : null}
      busy={busy}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );

export default OrgRemoveConfirm;
